import styled from "styled-components";

import { PrimaryText } from "@/components/Typography/Styled";

export const StyledFactValue = styled(PrimaryText)<{ isFactComleted: boolean }>`
    color: ${({ isFactComleted }) =>
        isFactComleted ? "#49AA19" : "#D32029"} !important;
`;

export const StyledProductTagSpecial = styled.div<{ isDropout: boolean }>`
    padding: 2px 7px;
    border-radius: 12px;
    font-family: Inter;
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    letter-spacing: 0%;
    min-height: 20px;
    max-height: 20px;
    color: ${({ isDropout }) => (isDropout ? "#AB7AE0" : "#3c89e8")};
    background-color: ${({ isDropout }) => (isDropout ? "#301C4D" : "#15325b")};
`;
